<template>
    <v-container>
        <v-layout align-center
                  justify-center
                  text-center
                  >
            <h1 style="font-size: 39px; font-weight: normal" class="mb-4 mt-6">Geschäftsführende Gesellschafterin</h1>
        </v-layout>
        <v-layout
                text-center
                wrap
                justify-center
                style="margin-bottom: 2%">
            <v-flex xs12>
                <v-avatar
                        size=150>
                    <img src="../assets/AvatarGolzo.jpeg" alt="avatar">
                </v-avatar>
            </v-flex>
            <v-flex xs12>
                <p style="margin-bottom: 0px"><b>Annette Golzo</b></p>
            </v-flex>
            <v-flex>
                CEO / Rechtsanwältin
            </v-flex>
        </v-layout>
      <!--
        <v-layout align-center
                  justify-center
                  text-center
        >
            <h1 style="font-size: 39px; font-weight: normal" class="mb-4">Chief Operating Officer</h1>
        </v-layout>
        <v-layout
                text-center
                wrap
                justify-center
                style="margin-bottom: 2%">
            <v-flex xs12>
                <v-avatar
                        size=150>
                    <img src="../assets/AvatarStef.jpeg" alt="avatar">
                </v-avatar>
            </v-flex>
            <v-flex xs12>
                <p style="margin-bottom: 0px"><b>Stefan J. Weiland</b></p>
                <v-btn icon href="tel:+49 6021 3627988" style="padding: 0px">
                    <v-icon :style="$vuetify.theme.dark ? 'color: white;' : 'color: black;'"  size="16">mdi-phone-classic</v-icon>
                </v-btn>
            </v-flex>

        </v-layout>
      -->
    </v-container>
</template>
<script>
    export default {
        data: () => ({}),
    };
</script>
